import DocViewShell from "@/components/DocViewShell";
import TocBlueprint from "@/components/blueprints/TocBlueprint";

export default function TocView() {
  return (
    <DocViewShell
      eyebrow="Theory of Constraints"
      eyebrowClass="text-blue-700"
      toolName="Theory of Constraints"
      editPathFn={(id) => `/toc/${id}`}
      render={(doc) => <TocBlueprint doc={doc} />}
    />
  );
}
